import React, { memo } from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import { When } from 'UI/components/atoms/When';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';

import { useTeamFilters } from './TeamFilters.hooks';

const TeamFiltersComponent = ({ onFilterChange, initialFilters }) => {
  const {
    selectedCoach,
    selectedRecruiter,
    shouldShowTeamSelector,
    shouldShowRecruiterSelector,
    availableCoaches,
    recruiterUrl,
    defaultRecruiterOption,
    recruiterPrependOptions,
    handleCoachSelect,
    handleRecruiterSelect
  } = useTeamFilters(onFilterChange, initialFilters);

  const isLeadRole = shouldShowTeamSelector || shouldShowRecruiterSelector;

  if (!isLeadRole) return null;

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <When condition={shouldShowTeamSelector}>
          <Grid item xs={12} sm={6} md={4}>
            <AutocompleteSelect
              name="coachFilter"
              placeholder={strings.dailyPlan.filters.leadership.teams}
              selectedValue={selectedCoach}
              onSelect={handleCoachSelect}
              options={availableCoaches}
              displayKey="full_name"
              prependOptions={[]}
              disableClearable={false}
            />
          </Grid>
        </When>

        <When condition={shouldShowRecruiterSelector}>
          <Grid item xs={12} sm={6} md={4}>
            <AutocompleteSelect
              name="recruiterFilter"
              placeholder={strings.dailyPlan.filters.leadership.recruiters}
              selectedValue={selectedRecruiter || defaultRecruiterOption}
              onSelect={handleRecruiterSelect}
              url={recruiterUrl}
              displayKey="full_name"
              prependOptions={recruiterPrependOptions}
              disableClearable={!!defaultRecruiterOption}
              disabled={shouldShowTeamSelector && !selectedCoach}
              freeSolo
              forcePopupIcon
            />
          </Grid>
        </When>
      </Grid>
    </Grid>
  );
};

export const TeamFilters = memo(TeamFiltersComponent);
